import Vue from 'vue';
import Vuex from 'vuex';
import {env} from '@/services/env.service';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';
import getInitialState from './appState';
import theme from './modules/theme.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
  strict: env.MODE === 'production' || env.MODE === 'testing',
  state: getInitialState(),
  modules: {
    theme,
  },
  actions,
  mutations,
  getters,
});

export default store;
export const useVuexStore = () => store;
